const UsersConstants = {
  
}

const AllConstants = {
  UsersConstants
}

export default AllConstants;
